export const GROUP_COLOR_MAP: Record<
  string,
  { dot: string; badgeBg: string; badgeText: string }
> = {
  emerald: { dot: '#10b981', badgeBg: '#d1fae5', badgeText: '#065f46' },
  sky: { dot: '#0ea5e9', badgeBg: '#e0f2fe', badgeText: '#0369a1' },
  amber: { dot: '#f59e0b', badgeBg: '#fef3c7', badgeText: '#92400e' },
  slate: { dot: '#94a3b8', badgeBg: '#f1f5f9', badgeText: '#475569' },
  indigo: { dot: '#6366f1', badgeBg: '#e0e7ff', badgeText: '#3730a3' },
}
